import React from 'react';

export default function RoundImage({ image }) {
  return (
    <div className="round-image">
      <img src={image} alt="" />
    </div>
  );
}
